import React from 'react';
import { PlayGameLink } from './index';

export default function SpotTheBallPage() {
  return (
    <div className="mx-auto max-w-3xl rounded-xl bg-white p-6 shadow dark:bg-slate-900">
      <div className="text-sm font-semibold uppercase tracking-[0.18em] text-emerald-600 dark:text-emerald-300">Spot The Ball</div>
      <h1 className="mt-2 text-3xl font-bold text-slate-900 dark:text-slate-100">Find the missing football</h1>
      <p className="mt-3 text-slate-600 dark:text-slate-300">Every round shows an image where the football has been removed. Place your marker where you think the ball should be, submit before the timer ends, and score by closeness.</p>
      <PlayGameLink game="SpotTheBall" gameTitle="Spot The Ball" />
    </div>
  );
}